/**
 * @param {object} obj - The source object to flatten.
 * @param {string} [parent] - The parent key used to build the flattened property name (used internally in recursion).
 * @param {object} [res={}] - The accumulator object that stores the flattened result.
 * @returns {object} The flattened object.
 */
export default function flattenObj(obj, parent, res = {}) {
    // eslint-disable-next-line
    for (const key in obj) {
        const propName = parent ? `${parent}.${key}` : key
        if (typeof obj[key] === 'object' && Object.prototype.toString.call(obj[key]) !== '[object Date]')
            flattenObj(obj[key], propName, res)
        else
            res[propName] = obj[key]
    }
    return res
}
